<br/>
<div class="row">
    <div class="col-12">

        <div class="tab-content" *ngIf="isf">

            <table class="table table-sm table-borderless m-0 p-0">
                <tbody>
                    <tr>
                        <th>Status:</th>
                        <td><isf-status [status]="isf.status"></isf-status></td>
                    </tr>
                    <tr>
                        <th>Created:</th>
                        <td>{{isf.createdBy}} &#64; {{isf.createdAt | date:'mediumDate' }}</td>
                    </tr>
                    <tr>
                        <th>Last Update:</th>
                        <td>{{isf.updatedBy}} &#64; {{isf.updatedAt | date:'mediumDate'}}</td>
                    </tr>

                    <tr *ngIf="isf?.validationErrors && isf.validationErrors.length > 0">
                        <th>Validation Error</th>
                        <td>
                            <table class="table table-sm table-bordered">
                                <thead>
                                <tr class="bg-secondary text-white">
                                    <th>Datetime</th>
                                    <th>Message</th>
                                </tr>
                                </thead>
                                <tr *ngFor="let e of isf.validationErrors">
                                    <td>{{e.dateTime | date:'medium'}}</td>
                                    <td>{{e.message}}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>


                    <tr>
                        <th>CBP Result</th>
                        <td>
                            <div *ngIf="isf.response" style="max-height: 400px; overflow-y: scroll;">
                                <table class="table table-sm table-bordered isf-response">
                                    <thead>
                                        <tr class="bg-secondary text-white">
                                            <th></th>
                                            <th>Datetime</th>
                                            <th>Message</th>
                                            <th>Submitted By</th>
                                            <th>Conditions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let r of isfResponse">
                                            <td class="icon">
                                                <span *ngIf="r.messageType == '01'" class="badge isf-rejected text-danger">
                                                    <i class="fa fa-thumbs-down"></i>
                                                </span>
                                                <span *ngIf="r.messageType == '02'" class="badge isf-accepted text-success">
                                                    <i class="fa fa-check-circle"></i>
                                                </span>
                                            </td>
                                            <td><span>{{r?.dateTime | date:'mediumDate'}}</span></td>
                                            <td><span>{{r?.message}}</span></td>
                                            <td><span>{{r?.submittedBy}}</span></td>
                                            <td>
                                                <table class="table table-sm isf-response p-0 m-0">
                                                    <tbody>
                                                        <tr *ngFor="let e of r?.conditions">
                                                            <td>{{e.message}}</td>
                                                            <td>{{e.error}}</td>
                                                            <td>{{e.record}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>

    </div>
</div>
